import { FlowContext } from 'src/lib/flow';
import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { yourHome } from 'src/lib/flow/text';

import { isAgent } from '../../../../lib/flow/pageHelpers';

function isEnabled({ answers, inputContext: { eligibleProducts, channel } }: FlowContext) {
  const opendoorDirectEligible = eligibleProducts.includes('opendoor_direct');
  if (isAgent(answers, channel)) {
    return false;
  }
  return opendoorDirectEligible;
}

function title({ answers, inputContext: { channel } }: FlowContext): string {
  return `How much do you think ${yourHome(answers, channel)} should sell for today?`;
}

const priceEstimatePage: FlowPage = {
  slug: () => 'price-estimate',
  isEnabled,
  title,
  autoAdvance: () => false,
  questions: (): FlowQuestion[] => [
    {
      key: 'seller.price_estimate_range',
      type: 'range',
      minValue: 0,
      maxValue: 10000000,
      optional: true,
      minLabel: 'Minimum amount',
      maxLabel: 'Maximum amount',
      placeholder: '$0',
      prefix: '$',
    },
  ],
};

export default priceEstimatePage;
